import I18N from '@leverege/i18n';
import ApiSuggestions from "./ApiSuggestions.js";
const {
  tf
} = I18N.ns('molten.screens.group.ApiSuggestions');
export default {
  id: 'ApiSuggestions',
  name: tf('name'),
  matches: {
    use: 'suggestions',
    client: 'molten.group.SearchBar'
  },
  handles: () => true,
  // could be useful for recent searches
  onSearchChange: ({
    search
  }) => {},
  suggestions: ApiSuggestions
};